
export const CheckmarkLogo = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='checkmark'
  >
    <path
      d='M7.94771 16C12.3378 16 15.8954 12.4173 15.8954 8C15.8954 3.581 12.3362 0 7.94771 0C3.55924 0 0 3.58266 0 8C0 12.419 3.55924 16 7.94771 16Z'
      fill='#00CD98'
    />
    <path
      d='M12.0049 4.83243C12.1961 5.00003 12.2175 5.29208 12.051 5.48458C12.0494 5.48789 12.0461 5.48955 12.0444 5.49287L7.04436 11.1531C6.87291 11.3456 6.57946 11.3639 6.38658 11.1913C6.37339 11.1797 6.3602 11.1664 6.34866 11.1531L3.84944 8.3205C3.67964 8.12469 3.69778 7.82766 3.89231 7.65674C4.08684 7.48582 4.38193 7.50407 4.55173 7.69988L6.72289 10.1376L11.3751 4.854C11.5416 4.66151 11.8318 4.63994 12.023 4.80754C12.0263 4.81086 12.028 4.81252 12.0313 4.81583L12.0049 4.83243Z'
      fill='white'
    />
  </svg>
);
